var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:[
            'cz2__input-box',
            'cz2__input-box--active',
            {
                'cz2__input-box--small-font': _vm.smallFont,
                'cz2__input-box--invalid': _vm.invalid,
                'cz2__input-box--outline': _vm.outlined,
            },
        ]},[_c('input',{ref:"input",attrs:{"type":"text","maxlength":_vm.lengthLimit,"placeholder":_vm.inputPlaceholder,"aria-labelledby":_vm.labelledBy,"readonly":_vm.readOnly},domProps:{"value":_vm.inputText},on:{"focus":_vm.focused,"blur":_vm.closeKeyboard,"input":_vm.emitInput}}),_c('span',{staticClass:"cz2__input-box__error"},[_vm._v(" "+_vm._s(_vm.errorText)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }